/* eslint-disable prefer-destructuring */
import { SafeEnv } from 'SharedDir/utils/helpers';

export const DADATA_KEY = SafeEnv(() => process.env.DADATA_API_KEY);

export const YANDEX_KEY = SafeEnv(() => process.env.YANDEX_API_KEY);

export const ADMIN_URL = SafeEnv(() => process.env.ADMIN_URL);

export const PORTAL_URL = SafeEnv(() => process.env.PORTAL_URL);

export const WAF_SUPPORT = SafeEnv(() => process.env.WAF_SUPPORT_MAIL);

export const TEST_MODE_BANNER: boolean = SafeEnv(() => process.env.BANNER_TEST_MODE) === 'true';

export const YANDEX_METRIC_CODE = SafeEnv(() => process.env.YANDEX_METRIC_CODE);

export const REGION_ENVIRONMENT = SafeEnv(() => process.env.REGION_ENVIRONMENT) ?? 'hmao';

export const ETHNOPORTAL_URL = SafeEnv(() => process.env.ETHNOPORTAL_URL);

export const IS_VISIBLE_AI_SEARCH = SafeEnv(() => process.env.IS_VISIBLE_AI_SEARCH) === 'true';
